/**
 * Shared setup for all Vite entrypoints.
 * Import this file at the top of each entrypoint to ensure
 * global variables and polyfills are available.
 */
import _ from 'lodash'
import moment from 'moment'
import './configured-axios'

// Expose globals for legacy code that expects them on window
window._ = _
window.moment = moment

// For compatibility with Node.js-style code
if (typeof window !== 'undefined') {
    window.global = window
}
